import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { GoalsPage } from './pages/GoalsPage';
import { CreateGoalPage } from './pages/CreateGoalPage';
import { FocusModePage } from './pages/FocusModePage';
import { ProfilePage } from './pages/ProfilePage';
import { EditProfilePage } from './pages/EditProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { UpgradePage } from './pages/UpgradePage';
import { NotificationsPage } from './pages/NotificationsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated
  } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" data-id="element-0" />;
}
export function App() {
  return <ThemeProvider data-id="element-1">
      <AuthProvider data-id="element-2">
        <SubscriptionProvider data-id="element-3">
          <UserProvider data-id="element-4">
            <NotificationProvider data-id="element-5">
              <Router data-id="element-6">
                <Toaster position="top-right" richColors closeButton toastOptions={{
                style: {
                  fontFamily: 'Quicksand, sans-serif'
                },
                className: 'font-quicksand'
              }} data-id="element-7" />
                <Routes data-id="element-8">
                  {/* Public Routes */}
                  <Route path="/login" element={<LoginPage data-id="element-10" />} data-id="element-9" />
                  <Route path="/signup" element={<SignupPage data-id="element-12" />} data-id="element-11" />
                  <Route path="/onboarding" element={<OnboardingPage data-id="element-14" />} data-id="element-13" />

                  {/* Protected Routes */}
                  <Route path="/" element={<ProtectedRoute data-id="element-16">
                        <HomePage data-id="element-17" />
                      </ProtectedRoute>} data-id="element-15" />
                  <Route path="/goals" element={<ProtectedRoute data-id="element-19">
                        <GoalsPage data-id="element-20" />
                      </ProtectedRoute>} data-id="element-18" />
                  <Route path="/create-goal" element={<ProtectedRoute data-id="element-22">
                        <CreateGoalPage data-id="element-23" />
                      </ProtectedRoute>} data-id="element-21" />
                  <Route path="/focus" element={<ProtectedRoute data-id="element-25">
                        <FocusModePage data-id="element-26" />
                      </ProtectedRoute>} data-id="element-24" />
                  <Route path="/leaderboard" element={<ProtectedRoute data-id="element-28">
                        <LeaderboardPage data-id="element-29" />
                      </ProtectedRoute>} data-id="element-27" />
                  <Route path="/profile" element={<ProtectedRoute data-id="element-31">
                        <ProfilePage data-id="element-32" />
                      </ProtectedRoute>} data-id="element-30" />
                  <Route path="/edit-profile" element={<ProtectedRoute data-id="element-34">
                        <EditProfilePage data-id="element-35" />
                      </ProtectedRoute>} data-id="element-33" />
                  <Route path="/settings" element={<ProtectedRoute data-id="element-37">
                        <SettingsPage data-id="element-38" />
                      </ProtectedRoute>} data-id="element-36" />
                  <Route path="/analytics" element={<ProtectedRoute data-id="element-40">
                        <AnalyticsPage data-id="element-41" />
                      </ProtectedRoute>} data-id="element-39" />
                  <Route path="/upgrade" element={<ProtectedRoute data-id="element-43">
                        <UpgradePage data-id="element-44" />
                      </ProtectedRoute>} data-id="element-42" />
                  <Route path="/notifications" element={<ProtectedRoute data-id="element-46">
                        <NotificationsPage data-id="element-47" />
                      </ProtectedRoute>} data-id="element-45" />
                  <Route path="/privacy" element={<ProtectedRoute data-id="element-49">
                        <PrivacyPage data-id="element-50" />
                      </ProtectedRoute>} data-id="element-48" />
                </Routes>
              </Router>
            </NotificationProvider>
          </UserProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </ThemeProvider>;
}